import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set title immediately before React mounts
document.title = 'Megapack Estimulación Temprana — Construye Progreso™';
// Preconnect to critical origins BEFORE React renders
const origins = [{
  href: 'https://cdn.magicpatterns.com',
  crossOrigin: 'anonymous'
}, {
  href: 'https://images.unsplash.com',
  crossOrigin: 'anonymous'
}];
origins.forEach(({
  href,
  crossOrigin
}) => {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  if (crossOrigin) link.crossOrigin = crossOrigin;
  document.head.appendChild(link);
});
// Preload hero image for faster LCP
const preloadImg = document.createElement('link');
preloadImg.rel = 'preload';
preloadImg.as = 'image';
preloadImg.href = 'https://cdn.magicpatterns.com/uploads/v7HbDBttB6KwqMN8KX8fXz/hf_20260408_171512_ee149707-ab8e-4b03-a52c-19e854e7886e_(1)-Photoroom.webp';
document.head.appendChild(preloadImg);
render(<App data-id="element-372" />, document.getElementById('root'));